import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const HERO = "https://images.unsplash.com/photo-1743677077216-00a458eff9e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxzdHVkZW50cyUyMHJvYm90aWNzJTIwdGVjaG5vbG9neSUyMGxhYiUyMGxlYXJuaW5nfGVufDB8fHx8MTc5MDMyNDYwOXww&ixlib=rb-4.1.0&q=85";

export default function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to H.E.A.! Add your first child to get started.");
      navigate("/students");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="flex flex-col justify-center px-6 py-12 lg:px-20">
        <Logo />
        <div className="mx-auto mt-10 w-full max-w-sm">
          <h1 className="font-display text-3xl font-bold text-navy">Join H.E.A.</h1>
          <p className="mt-2 text-slateBrand">Create one family account. Add your children next.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label className="font-display font-semibold text-navy">Guardian name</Label>
              <Input data-testid="register-name" required value={form.name} onChange={set("name")} className="mt-1.5 h-12" placeholder="Rachel Bennett" />
            </div>
            <div>
              <Label className="font-display font-semibold text-navy">Email</Label>
              <Input data-testid="register-email" type="email" required value={form.email} onChange={set("email")} className="mt-1.5 h-12" placeholder="you@example.com" />
            </div>
            <div>
              <Label className="font-display font-semibold text-navy">Phone</Label>
              <Input data-testid="register-phone" value={form.phone} onChange={set("phone")} className="mt-1.5 h-12" placeholder="904-555-0100" />
            </div>
            <div>
              <Label className="font-display font-semibold text-navy">Password</Label>
              <Input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={set("password")} className="mt-1.5 h-12" placeholder="At least 6 characters" />
            </div>
            <Button data-testid="register-submit" disabled={loading} className="h-12 w-full bg-brandblue font-display text-base font-semibold hover:bg-blue-700">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Create Account"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-slateBrand">Already have an account? <Link to="/login" className="font-semibold text-brandblue">Log in</Link></p>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-display text-2xl font-bold text-white">Turn Curiosity Into Experience.</p>
        </div>
      </div>
    </div>
  );
}
